import { render, staticRenderFns } from "./tab-complete.vue?vue&type=template&id=a570980e"
import script from "./tab-complete.vue?vue&type=script&lang=js"
export * from "./tab-complete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports